var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _g3, _g4, _g5, _g6, _g7, _path8, _path9, _path10, _path11, _path12, _path13, _g8, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g9, _g10, _path24, _path25, _path26, _path27, _g11, _g12, _g13, _path28, _path29, _path30, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 760.193,
    height: 626.522,
    viewBox: "0 0 760.193 626.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "verification",
    transform: "translate(0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M941.555,653.038c-14.614,33.025-34.88,59.2-59.117,79.725-27.988,23.711-61.273,39.9-97.268,50.423-117.113,34.258-262.89,8.615-348.137-12.659-17.287-4.315-32.084-8.451-43.648-11.87A188.443,188.443,0,0,1,338.694,732.4l-.261-.183C224.189,652.1,175.667,537.6,213.653,429.157c.59-1.692,112.59-346.095,378.164-232.353C708.4,246.738,665.52,289.169,794.75,342.24c60.417,24.813,140.367,69.072,162.3,173.474C964.875,552.973,962.239,606.293,941.555,653.038Z",
    transform: "translate(-200.914 -173.771)",
    fill: "#c9e1fd",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11342",
    "data-name": "Group 11342",
    transform: "translate(-136.111 5.316)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(136.111 576.987)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    cx: 378.574,
    cy: 22.109,
    rx: 378.574,
    ry: 22.109,
    transform: "translate(0)",
    fill: "#d3e5f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(776.933 408.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M407.663,460.419s9.275-20.236-1.322-40.185-13.67-24.649-6.914-28.735,9.854,15.958,9.854,15.958,5.694-13.791.992-28.222-7.65-37.94-1.23-40.46,1.226,29.325,6.8,40.179c0,0,4.68-12.084,5.449-23.676s-.433-30.1,4.637-34.851,8.32-1.462,3.337,24.12a267.5,267.5,0,0,0-4.948,46.376s11.006-33.558,18.393-34.536,7.379,9.888,1.054,19.314-18.516,26.312-20.515,35c0,0,12.08-25.254,22.948-17.514s-9.46,22.995-18.518,28.5-15.351,40.062-15.351,40.062Z",
    transform: "translate(-373.329 -318.593)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M407.663,460.419s9.275-20.236-1.322-40.185-13.67-24.649-6.914-28.735,9.854,15.958,9.854,15.958,5.694-13.791.992-28.222-7.65-37.94-1.23-40.46,1.226,29.325,6.8,40.179c0,0,4.68-12.084,5.449-23.676s-.433-30.1,4.637-34.851,8.32-1.462,3.337,24.12a267.5,267.5,0,0,0-4.948,46.376s11.006-33.558,18.393-34.536,7.379,9.888,1.054,19.314-18.516,26.312-20.515,35c0,0,12.08-25.254,22.948-17.514s-9.46,22.995-18.518,28.5-15.351,40.062-15.351,40.062Z",
    transform: "translate(-373.329 -318.593)",
    fill: "#26b462",
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M425.6,464.819s-9.03-20.371,1.8-40.161,13.964-24.442,7.259-28.63-10.046,15.812-10.046,15.812-5.53-13.875-.654-28.235,8.1-37.822,1.714-40.439-1.578,29.3-7.279,40.076c0,0-4.534-12.155-5.164-23.756s.793-30.092-4.219-34.917-8.3-1.585-3.626,24.067a267.758,267.758,0,0,1,4.389,46.447s-10.6-33.718-17.975-34.808-7.5,9.778-1.287,19.3,18.2,26.586,20.1,35.3c0,0-11.778-25.43-22.737-17.854s9.183,23.134,18.174,28.78,14.868,40.286,14.868,40.286Z",
    transform: "translate(-383.948 -314.695)",
    fill: "#2ecc71"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 135.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M384.313,388.043h74.608l-6.038,53.39H390.351Z",
    transform: "translate(-384.313 -388.043)",
    fill: "#108387"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(170.903 138.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(119.383 289.03)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M345.024,489.54v7.013a1.572,1.572,0,0,1-1.585,1.568H145.414a10.32,10.32,0,0,1-9.583-14.173l62.754-155.419,101.41.693-3.462,20.164L274.163,479.9a6.9,6.9,0,0,0,6.795,8.07h62.481A1.571,1.571,0,0,1,345.024,489.54Z",
    transform: "translate(-135.073 -328.529)",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M345.024,489.54v7.013a1.572,1.572,0,0,1-1.585,1.568H145.414a10.32,10.32,0,0,1-9.583-14.173l38.91-96.343,23.844-59.076,101.41.693-3.462,20.164-9.728,56.762L274.163,479.9a6.9,6.9,0,0,0,6.795,8.07h62.481A1.571,1.571,0,0,1,345.024,489.54Z",
    transform: "translate(-135.073 -328.529)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M274.852,477.8H146.009a4.521,4.521,0,0,1-4.174-6.256l55.016-132.332h93.577L268.057,469.73A6.9,6.9,0,0,0,274.852,477.8Z",
    transform: "translate(-128.967 -318.354)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M280.643,329.221l-3.461,20.165-9.728,56.761L155.389,387.6l23.845-59.074Z",
    transform: "translate(-115.722 -328.529)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M555.431,180.5H85.944A12.014,12.014,0,0,0,73.93,192.516V510.35a12.013,12.013,0,0,0,12.014,12.014H555.431a12.014,12.014,0,0,0,12.014-12.014V192.516A12.015,12.015,0,0,0,555.431,180.5Z",
    transform: "translate(-73.93 -180.5)",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M555.431,180.5H85.944A12.014,12.014,0,0,0,73.93,192.516V510.35a12.013,12.013,0,0,0,12.014,12.014H555.431a12.014,12.014,0,0,0,12.014-12.014V192.516A12.015,12.015,0,0,0,555.431,180.5Z",
    transform: "translate(-73.93 -180.5)",
    fill: "#fff",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M95.886,522.356H85.934a12,12,0,0,1-12-12V192.522a12.006,12.006,0,0,1,12-12.022h9.952a12.006,12.006,0,0,0-12,12.022V510.356A12,12,0,0,0,95.886,522.356Z",
    transform: "translate(-73.926 -180.5)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(20.791 10.323)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 461.903,
    height: 306.484,
    fill: "#125082"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(20.785 11.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M498.339,186.524C434.474,250.508,270.44,392.908,84.575,382.38V186.524Z",
    transform: "translate(-84.575 -186.524)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M456.809,247.909V436.8H178.718c10.667-38.152,31.98-90.4,73.339-127.732C326.45,241.9,412.785,242.1,456.809,247.909Z",
    transform: "translate(5.099 -130.308)",
    fill: "#fff",
    opacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(105.578 46.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(99.691)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 40.103,
    cy: 40.103,
    r: 40.103,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(20.876 19.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(5.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M196.785,229.022v-3.753a6.611,6.611,0,0,1,6.605-6.605h5.924a6.611,6.611,0,0,1,6.6,6.605v3.753H220.2v-3.753a10.894,10.894,0,0,0-10.881-10.883H203.39a10.893,10.893,0,0,0-10.881,10.883v3.753Z",
    transform: "translate(-192.509 -214.386)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M189.752,225.471v19.711a2.18,2.18,0,0,0,2.179,2.179h34.093a2.18,2.18,0,0,0,2.181-2.179V225.471a2.18,2.18,0,0,0-2.181-2.179H191.931A2.18,2.18,0,0,0,189.752,225.471Zm20.461,11.163v3.874h-2.468v-3.874a2.4,2.4,0,0,1-1.2-2.048,2.433,2.433,0,0,1,4.866,0A2.4,2.4,0,0,1,210.213,236.634Z",
    transform: "translate(-189.752 -205.903)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(89.341 93.388)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M180.528,261.032v.875h-6.769v-9.571h6.564v.875h-5.551v3.4h4.95v.863h-4.95v3.556Z",
    transform: "translate(-173.759 -252.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M184.956,256.6v4.169h-.97V256.7a2.008,2.008,0,0,0-2.161-2.3,2.359,2.359,0,0,0-2.517,2.6v3.772h-.97v-7.191h.931v1.324a3.021,3.021,0,0,1,2.734-1.38A2.755,2.755,0,0,1,184.956,256.6Z",
    transform: "translate(-169.398 -251.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M187.411,261.078a2.31,2.31,0,0,1-1.517.5,1.9,1.9,0,0,1-2.107-2.091v-4.348H182.5v-.82h1.285v-1.574h.972v1.574h2.187v.82h-2.187v4.294A1.151,1.151,0,0,0,186,260.748a1.606,1.606,0,0,0,1.066-.369Z",
    transform: "translate(-165.431 -251.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M192.4,257.479h-6.018a2.664,2.664,0,0,0,2.831,2.5,2.838,2.838,0,0,0,2.2-.943l.547.629a3.8,3.8,0,0,1-6.551-2.488,3.465,3.465,0,0,1,3.515-3.653,3.428,3.428,0,0,1,3.487,3.653C192.416,257.26,192.4,257.368,192.4,257.479Zm-6.018-.726h5.1a2.555,2.555,0,0,0-5.1,0Z",
    transform: "translate(-162.657 -251.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M193.637,253.525v.945c-.082,0-.164-.014-.232-.014-1.505,0-2.421.957-2.421,2.651v3.665h-.97v-7.191h.929v1.406A2.716,2.716,0,0,1,193.637,253.525Z",
    transform: "translate(-158.277 -251.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M201.525,253.554l-3.595,8.054c-.6,1.408-1.369,1.859-2.394,1.859a2.465,2.465,0,0,1-1.751-.656l.453-.724a1.8,1.8,0,0,0,1.312.547c.642,0,1.08-.3,1.49-1.2l.314-.7-3.214-7.178h1.013l2.708,6.111,2.706-6.111Z",
    transform: "translate(-154.684 -251.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M197.972,257.178a3.658,3.658,0,1,1,3.665,3.663A3.539,3.539,0,0,1,197.972,257.178Zm6.33,0a2.676,2.676,0,1,0-2.665,2.8A2.622,2.622,0,0,0,204.3,257.178Z",
    transform: "translate(-150.696 -251.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M209.248,253.554v7.191h-.929v-1.312a2.861,2.861,0,0,1-2.585,1.38,2.786,2.786,0,0,1-3.036-3.089v-4.171h.97v4.075a2.013,2.013,0,0,0,2.161,2.31,2.34,2.34,0,0,0,2.448-2.612v-3.772Z",
    transform: "translate(-146.195 -251.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M211.067,253.525v.945c-.082,0-.164-.014-.232-.014-1.505,0-2.421.957-2.421,2.651v3.665h-.97v-7.191h.929v1.406A2.714,2.714,0,0,1,211.067,253.525Z",
    transform: "translate(-141.674 -251.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M211.754,257.161a5.028,5.028,0,1,1,5.034,4.868A4.818,4.818,0,0,1,211.754,257.161Zm9.04,0a4.021,4.021,0,1,0-4.007,3.966A3.878,3.878,0,0,0,220.794,257.161Z",
    transform: "translate(-137.568 -252.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M220.585,253.21h-3.364v-.875h7.74v.875H221.6v8.7h-1.011Z",
    transform: "translate(-132.36 -252.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M229.5,255.617c0,2.038-1.478,3.269-3.913,3.269h-2.57v3.021h-1.013v-9.571h3.583C228.027,252.335,229.5,253.565,229.5,255.617Zm-1.013,0c0-1.533-1.011-2.407-2.925-2.407h-2.544V258h2.544C227.48,258,228.491,257.121,228.491,255.617Z",
    transform: "translate(-127.8 -252.253)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(101.812 175.394)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M180.146,303.038l.4-.779a4.7,4.7,0,0,0,3.159,1.162c1.792,0,2.571-.752,2.571-1.695,0-2.626-5.895-1.013-5.895-4.553,0-1.41,1.093-2.626,3.528-2.626a5.417,5.417,0,0,1,2.968.845l-.342.808a4.935,4.935,0,0,0-2.626-.795c-1.749,0-2.53.781-2.53,1.738,0,2.626,5.895,1.039,5.895,4.526,0,1.41-1.121,2.613-3.569,2.613A5.189,5.189,0,0,1,180.146,303.038Z",
    transform: "translate(-180.146 -294.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M191.432,299.732h-6.018a2.665,2.665,0,0,0,2.831,2.5,2.838,2.838,0,0,0,2.2-.943l.547.629a3.8,3.8,0,0,1-6.551-2.489,3.466,3.466,0,0,1,3.515-3.651,3.428,3.428,0,0,1,3.487,3.651C191.446,299.511,191.432,299.621,191.432,299.732Zm-6.018-.726h5.1a2.556,2.556,0,0,0-5.1,0Z",
    transform: "translate(-176.052 -292.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M195.662,298.855v4.171h-.972v-4.075a2.007,2.007,0,0,0-2.16-2.3,2.359,2.359,0,0,0-2.517,2.6v3.772h-.97v-7.191h.929v1.324a3.025,3.025,0,0,1,2.735-1.38A2.755,2.755,0,0,1,195.662,298.855Z",
    transform: "translate(-171.671 -292.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M200.714,294.293V304.44h-.929v-1.421a3.12,3.12,0,0,1-2.777,1.49,3.659,3.659,0,0,1,0-7.316,3.143,3.143,0,0,1,2.735,1.423v-4.323Zm-.959,6.551a2.676,2.676,0,1,0-2.665,2.8A2.629,2.629,0,0,0,199.755,300.844Z",
    transform: "translate(-167.497 -294.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M206.1,298.568v4.458h-.929V301.9a2.7,2.7,0,0,1-2.474,1.189c-1.628,0-2.626-.847-2.626-2.091,0-1.107.711-2.038,2.776-2.038h2.283v-.439c0-1.228-.7-1.9-2.036-1.9a3.668,3.668,0,0,0-2.394.847l-.437-.726a4.57,4.57,0,0,1,2.927-.97C205.045,295.778,206.1,296.709,206.1,298.568Zm-.97,2.3v-1.177H202.87c-1.394,0-1.845.547-1.845,1.287,0,.834.67,1.353,1.82,1.353A2.3,2.3,0,0,0,205.127,300.866Z",
    transform: "translate(-161.17 -292.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M211.533,295.835v6.316c0,2.476-1.216,3.6-3.6,3.6a5.007,5.007,0,0,1-3.351-1.109l.492-.736a4.283,4.283,0,0,0,2.831.982c1.818,0,2.654-.832,2.654-2.61v-.916a3.24,3.24,0,0,1-2.8,1.4,3.49,3.49,0,1,1,0-6.976,3.247,3.247,0,0,1,2.845,1.437v-1.38Zm-.943,3.419a2.73,2.73,0,1,0-2.736,2.638A2.572,2.572,0,0,0,210.59,299.253Z",
    transform: "translate(-157.283 -292.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M215.043,298.568v4.458h-.929V301.9a2.7,2.7,0,0,1-2.476,1.189c-1.626,0-2.624-.847-2.624-2.091,0-1.107.711-2.038,2.775-2.038h2.284v-.439c0-1.228-.7-1.9-2.038-1.9a3.662,3.662,0,0,0-2.392.847l-.437-.726a4.565,4.565,0,0,1,2.925-.97C213.991,295.778,215.043,296.709,215.043,298.568Zm-.97,2.3v-1.177h-2.257c-1.394,0-1.845.547-1.845,1.287,0,.834.67,1.353,1.818,1.353A2.3,2.3,0,0,0,214.073,300.866Z",
    transform: "translate(-152.648 -292.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M213.34,294.978a.7.7,0,0,1,.711-.685.69.69,0,0,1,.711.672.711.711,0,0,1-1.421.014Zm.219,2.271h.97v7.191h-.97Z",
    transform: "translate(-148.528 -294.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M221.954,298.855v4.171h-.972v-4.075a2.007,2.007,0,0,0-2.16-2.3,2.359,2.359,0,0,0-2.517,2.6v3.772h-.97v-7.191h.929v1.324a3.025,3.025,0,0,1,2.736-1.38A2.755,2.755,0,0,1,221.954,298.855Z",
    transform: "translate(-146.628 -292.878)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M288.462,340.316H179.648a16.22,16.22,0,0,1-16.222-16.222h0a16.22,16.22,0,0,1,16.222-16.22H288.462a16.221,16.221,0,0,1,16.222,16.22h0A16.221,16.221,0,0,1,288.462,340.316Z",
    transform: "translate(-94.261 -105.962)",
    fill: "#f48a21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11371",
    "data-name": "Group 11371",
    transform: "translate(66.193 208.634)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Submit",
    transform: "translate(74 15)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.441,
    y: 0
  }, "Submit"))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(105.578 159.951)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 46.042,
    height: 46.042,
    rx: 2.09,
    transform: "translate(0 0.26)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 46.042,
    height: 46.042,
    rx: 2.09,
    transform: "translate(58.386 0.195)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 46.042,
    height: 46.042,
    rx: 2.09,
    transform: "translate(116.773 0.13)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 46.042,
    height: 46.042,
    rx: 2.09,
    transform: "translate(175.159 0.065)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 46.042,
    height: 46.042,
    rx: 2.09,
    transform: "translate(233.545)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(246.423 11.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M254.21,280.872c0-8.1,4.333-12.715,10.157-12.715,5.789,0,10.122,4.618,10.122,12.715s-4.333,12.715-10.122,12.715C258.543,293.587,254.21,288.969,254.21,280.872Zm16.727,0c0-6.357-2.7-9.554-6.57-9.554-3.907,0-6.605,3.2-6.605,9.554s2.7,9.552,6.605,9.552C268.239,290.424,270.937,287.229,270.937,280.872Z",
    transform: "translate(-254.21 -268.157)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(13.058 11.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M153.9,280.554c0,8.488-4.793,13.033-11.754,13.033a11.982,11.982,0,0,1-6.18-1.457l1.349-2.769a8.764,8.764,0,0,0,4.8,1.17c5.043,0,8.238-3.159,8.238-9.374v-.888c-1.455,2.167-4.083,3.267-7.172,3.267-4.938,0-8.488-2.948-8.488-7.527,0-4.8,3.835-7.851,8.771-7.851C150.138,268.157,153.9,272.632,153.9,280.554Zm-4.368-4.723c0-2.56-2.06-4.8-5.93-4.8-3.231,0-5.469,1.882-5.469,4.829,0,2.913,2.167,4.8,5.647,4.8C147.19,280.659,149.533,278.564,149.533,275.83Z",
    transform: "translate(-134.69 -268.157)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(71.264 11.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M164.5,280.873c0-8.1,4.333-12.715,10.157-12.715,5.787,0,10.122,4.618,10.122,12.715s-4.335,12.715-10.122,12.715C168.834,293.588,164.5,288.97,164.5,280.873Zm16.727,0c0-6.357-2.7-9.554-6.57-9.554-3.907,0-6.605,3.2-6.605,9.554s2.7,9.554,6.605,9.554C178.528,290.427,181.228,287.23,181.228,280.873Z",
    transform: "translate(-164.501 -268.158)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(130.096 11.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M213.312,290.213V293.3H195.448v-2.415l10.122-9.765c2.628-2.558,3.124-4.122,3.124-5.682,0-2.558-1.81-4.122-5.291-4.122a7.806,7.806,0,0,0-6.355,2.7l-2.415-2.1c1.917-2.38,5.221-3.766,9.093-3.766,5.184,0,8.523,2.665,8.523,6.926,0,2.415-.711,4.583-4.085,7.814l-7.6,7.316Z",
    transform: "translate(-194.632 -268.157)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(191.893 11.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M235.408,268.3v24.858h-3.517V271.393h-5.61V268.3Z",
    transform: "translate(-226.282 -268.304)",
    fill: "#263238"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble",
    "data-name": "Speech bubble",
    transform: "translate(629.506 39.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M351.232,171.09l6.478,28.629,6.478-28.629Z",
    transform: "translate(-268.396 -90.042)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M351.232,171.09l6.478,28.629,6.478-28.629Z",
    transform: "translate(-268.396 -90.042)",
    fill: "#f48a21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 178.627,
    height: 87.39,
    rx: 8.592,
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 178.627,
    height: 87.39,
    rx: 8.592,
    fill: "#f48a21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(29.802 24.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M329.955,149.5v3.778h-1.546v-3.807l-4.338-7.121h1.669l3.5,5.762,3.513-5.762H334.3Z",
    transform: "translate(-324.07 -141.691)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M329.133,147.881a4.3,4.3,0,1,1,4.309,4.229A4.117,4.117,0,0,1,329.133,147.881Zm7.088,0a2.789,2.789,0,1,0-2.778,2.919A2.715,2.715,0,0,0,336.221,147.881Z",
    transform: "translate(-319.247 -140.434)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M342.356,143.705v8.273h-1.421V150.73a3.361,3.361,0,0,1-2.81,1.341,3.25,3.25,0,0,1-3.559-3.6v-4.762h1.5v4.588c0,1.625.81,2.437,2.232,2.437a2.436,2.436,0,0,0,2.56-2.749v-4.276Z",
    transform: "translate(-314.073 -140.395)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M344.471,143.665v1.451a2.646,2.646,0,0,0-.344-.016,2.469,2.469,0,0,0-2.607,2.8v4.12h-1.5v-8.273h1.437v1.39A3.151,3.151,0,0,1,344.471,143.665Z",
    transform: "translate(-308.876 -140.434)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M345.109,147.87a5.812,5.812,0,1,1,5.822,5.588A5.553,5.553,0,0,1,345.109,147.87Zm10.054,0a4.246,4.246,0,1,0-4.231,4.2A4.1,4.1,0,0,0,355.163,147.87Z",
    transform: "translate(-304.03 -141.751)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M355.144,143.7H351.4v-1.359h9.04V143.7H356.69v9.569h-1.546Z",
    transform: "translate(-298.04 -141.691)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M365.721,146.154c0,2.374-1.716,3.811-4.557,3.811h-2.7v3.308H356.9V142.345h4.264C364.005,142.345,365.721,143.782,365.721,146.154Zm-1.56,0c0-1.56-1.047-2.45-3.044-2.45h-2.655v4.9h2.655C363.115,148.607,364.161,147.716,364.161,146.154Z",
    transform: "translate(-292.799 -141.691)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M364.373,147.87a5.527,5.527,0,0,1,5.791-5.588,5.4,5.4,0,0,1,4.153,1.7l-1.015.984a4.048,4.048,0,0,0-3.075-1.3,4.2,4.2,0,1,0,0,8.4,4.062,4.062,0,0,0,3.075-1.312l1.015.984a5.42,5.42,0,0,1-4.169,1.716A5.523,5.523,0,0,1,364.373,147.87Z",
    transform: "translate(-285.68 -141.751)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M369.933,147.881a4.3,4.3,0,1,1,4.309,4.229A4.117,4.117,0,0,1,369.933,147.881Zm7.088,0a2.789,2.789,0,1,0-2.778,2.919A2.715,2.715,0,0,0,377.021,147.881Z",
    transform: "translate(-280.384 -140.434)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M383.585,142.01v11.582h-1.437v-1.31a3.492,3.492,0,0,1-2.95,1.4,4.223,4.223,0,0,1,0-8.445,3.525,3.525,0,0,1,2.888,1.326V142.01Zm-1.484,7.447a2.789,2.789,0,1,0-2.778,2.919A2.724,2.724,0,0,0,382.1,149.457Z",
    transform: "translate(-275.545 -142.01)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M388.679,148.38h-6.713a2.8,2.8,0,0,0,3,2.419,3.091,3.091,0,0,0,2.39-1l.826.968a4.51,4.51,0,0,1-7.711-2.888,4.051,4.051,0,0,1,4.151-4.216,3.989,3.989,0,0,1,4.09,4.262C388.711,148.052,388.7,148.238,388.679,148.38Zm-6.713-1.078h5.309a2.671,2.671,0,0,0-5.309,0Z",
    transform: "translate(-270.348 -140.434)",
    fill: "#f6faff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(52.84 43.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M349.779,161.079c0,6.145-3.472,9.437-8.509,9.437a8.688,8.688,0,0,1-4.475-1.054l.978-2.007a6.316,6.316,0,0,0,3.472.849c3.649,0,5.963-2.288,5.963-6.787v-.644a6,6,0,0,1-5.192,2.366c-3.575,0-6.147-2.134-6.147-5.451,0-3.472,2.777-5.682,6.352-5.682C347.055,152.105,349.779,155.344,349.779,161.079Zm-3.163-3.421c0-1.849-1.49-3.47-4.294-3.47-2.339,0-3.96,1.363-3.96,3.5,0,2.109,1.57,3.472,4.089,3.472C344.919,161.155,346.616,159.638,346.616,157.658Z",
    transform: "translate(-335.869 -152.105)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M344.26,161.309c0-5.861,3.138-9.2,7.355-9.2,4.19,0,7.328,3.343,7.328,9.2s-3.138,9.206-7.328,9.206C347.4,170.515,344.26,167.173,344.26,161.309Zm12.112,0c0-4.6-1.954-6.916-4.756-6.916-2.829,0-4.784,2.314-4.784,6.916s1.954,6.918,4.784,6.918C354.417,168.227,356.372,165.911,356.372,161.309Z",
    transform: "translate(-327.876 -152.105)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M366.085,168.073v2.236H353.152v-1.747l7.328-7.07c1.9-1.853,2.263-2.983,2.263-4.114,0-1.853-1.31-2.983-3.831-2.983a5.651,5.651,0,0,0-4.6,1.954l-1.749-1.517a8.3,8.3,0,0,1,6.584-2.726c3.753,0,6.17,1.929,6.17,5.014,0,1.748-.514,3.317-2.956,5.656l-5.5,5.3Z",
    transform: "translate(-319.97 -152.105)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M366.65,152.21v18H364.1V154.448h-4.061V152.21Z",
    transform: "translate(-312.843 -152.005)",
    fill: "#f6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M365.444,161.309c0-5.861,3.136-9.2,7.353-9.2,4.19,0,7.328,3.343,7.328,9.2s-3.138,9.206-7.328,9.206C368.58,170.515,365.444,167.173,365.444,161.309Zm12.11,0c0-4.6-1.954-6.916-4.756-6.916-2.829,0-4.784,2.314-4.784,6.916s1.954,6.918,4.784,6.918C375.6,168.227,377.554,165.911,377.554,161.309Z",
    transform: "translate(-307.698 -152.105)",
    fill: "#f6faff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(543.822 149.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M343.681,228.415s19.117,14.283,42.583,18.1c12.246,1.992-10.411-40.191-10.411-40.191",
    transform: "translate(-189.904 -167.008)",
    fill: "none",
    stroke: "#dc897c",
    strokeMiterlimit: 10,
    strokeWidth: 8.842
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(147.08 52.068)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M349.934,213.047a38.632,38.632,0,0,1,18.8,7.629l-7.859,24.172S322.976,209.96,349.934,213.047Z",
    transform: "translate(-340.25 -212.854)",
    fill: "#407bff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M349.861,233.457a158.215,158.215,0,0,0,11,11.385l3.231-9.933,4.635-14.226a38.451,38.451,0,0,0-18.785-7.634C333.362,211.153,341.29,223.6,349.861,233.457Z",
    transform: "translate(-340.251 -212.852)",
    fill: "#fff",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M345.2,225.086a158.211,158.211,0,0,0,11,11.385l3.231-9.933a23.118,23.118,0,0,0-14.173-4.887A18.635,18.635,0,0,0,345.2,225.086Z",
    transform: "translate(-335.588 -204.481)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M304.113,194.69s-18.158,60.38,20.092,68.481,42.261-19.679,42.261-19.679S335.131,195.92,304.113,194.69Z",
    transform: "translate(-231.696 -178.088)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(57.514 0.008)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M297.41,206.489s1.869-3.479,5.235-3.684",
    transform: "translate(-291.492 -170.366)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.482
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M300.98,208.772a29.481,29.481,0,0,1-1.576,6.883,3.831,3.831,0,0,0,4,.074Z",
    transform: "translate(-289.592 -164.682)",
    fill: "#de5753"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(5.901 38.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M298.421,208.639c.406,1.07,1.316,1.716,2.029,1.447s.963-1.361.555-2.431-1.314-1.718-2.029-1.447S298.013,207.567,298.421,208.639Z",
    transform: "translate(-296.616 -206.12)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M300.076,206.16l-2.675-.027S299.307,207.65,300.076,206.16Z",
    transform: "translate(-297.401 -206.133)",
    fill: "#263238"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M338.061,232.915a1.974,1.974,0,0,1-.273.488c-.176.332-.371.644-.566.976a18.622,18.622,0,0,1-4.491,5.369c-5.916,4.667-10.954,6.072-15.386,4.725-.215-.059-.43-.137-.644-.215l-.02.02c-6.58-2.675-11.637-10.544-15.8-20.951a41.356,41.356,0,0,1-3.378-12.848c0-.039-.059-.156-.059-.2,0-.156-.039-.351-.039-.508a15.306,15.306,0,0,1,6.17-13.219,29.635,29.635,0,0,1,5.662-3.495C328.865,183.536,347.843,214.5,338.061,232.915Z",
    transform: "translate(-291.501 -181.339)",
    fill: "#e4897b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M327.492,213.356A18.623,18.623,0,0,1,323,218.725c-5.916,4.667-10.954,6.072-15.386,4.725a21.4,21.4,0,0,0,11.11-6.738C320.834,214.235,324.036,213.376,327.492,213.356Z",
    transform: "translate(-281.771 -160.316)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M297.563,214.3s5.452,14.341,21.361,14.084c0,0,12.418,11.7,20.8,7.99,11.422-5.063,13.777-25.836,2.128-40.351C326.741,177.2,293.775,190.673,297.563,214.3Z",
    transform: "translate(-291.633 -185.286)",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M304.278,211.646c-1.015-2.16-.994-6.6,2.591-7.695,3.71-1.132,9.677,6.512,2.054,12.455C307.828,217.259,306.395,216.15,304.278,211.646Z",
    transform: "translate(-285.499 -169.382)",
    fill: "#e4897b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M317.438,189.126s-14.767,2.9-19.551,11.651c-5.586,10.22-5.785,18.153,9,23.333,0,0,18.752-17.651,26.832-19.611a88.107,88.107,0,0,1,14.361-2.3C342.714,186.835,323.392,182.653,317.438,189.126Z",
    transform: "translate(-294.379 -186.191)",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M313.544,223.656s10.155,7.039,12.8,18.625L358,223.818s-24.781-5.658-29.048-15.241C328.951,208.577,312.4,210.635,313.544,223.656Z",
    transform: "translate(-276.178 -164.868)",
    fill: "#e4897b"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M351.777,294.737s-40.921-40.3-45.416-52.945c0,0,17.233-26.853,51.7-27.976s57.906,64.437,57.906,64.437Z",
    transform: "translate(-225.452 -159.882)",
    fill: "#407bff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M415.96,278.266l-64.18,16.479s-8.943-8.806-18.939-19.467c-3.085-3.339-6.307-6.853-9.411-10.329-8.142-9.237-15.327-18.256-17.065-23.157,0,0,17.221-26.847,51.683-27.98C392.53,212.7,415.96,278.266,415.96,278.266Z",
    transform: "translate(-225.448 -159.886)",
    fill: "#fff",
    opacity: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M311.448,222.4s5.992,19.914,27.039,26.527,15.767,28.085,36.169,25.553c10.858-1.347,20.15-23.454-13.146-42.93-19.408-11.354-11.877-48.632-53.068-45.137C308.441,186.417,316.983,211.97,311.448,222.4Z",
    transform: "translate(-223.471 -186.187)",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M325.231,518.1l-9.753-2.22c1.466-48.77,8.511-107.848,14.747-152.184.982-6.951,1.929-13.521,2.851-19.644.445-2.911.861-5.707,1.275-8.4,2.015-13.295,3.743-23.8,4.817-30.3.789-4.739,1.24-7.34,1.24-7.34l35.093,8.579-2.515,8.857-8.3,29.243-.941,3.347-5.5,19.3-9.331,32.875C349.534,449.863,325.231,518.1,325.231,518.1Z",
    transform: "translate(-216.768 -79.674)",
    fill: "#e4897b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M374.589,513.58l-10-.5c-7.613-52.486-10.823-118.116-12.2-163.76-.205-7.072-.377-13.683-.514-19.67-.008-.31,0-.6-.014-.886-.254-11.887-.377-21.341-.433-27.328-.02-4.686-.037-7.258-.037-7.258l36.057,2.368L385.9,311.57l-2.265,22.081-.447,4.327-1.552,15.044-4.163,40.345C386.695,442.155,374.589,513.58,374.589,513.58Z",
    transform: "translate(-182.56 -83.324)",
    fill: "#e4897b"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(156.905 424.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M384.148,405.863c-.029-1.252-15.417-.271-15.417-.271s-9.466,9.628-18.66,11.793-4.057,7.681,6.221,7.681h25.422C389.016,425.066,384.453,418.845,384.148,405.863Z",
    transform: "translate(-345.283 -402.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(13.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M352.673,410.6a1.478,1.478,0,0,1-.373-1.64,1.647,1.647,0,0,1,.822-1.041,6.291,6.291,0,0,1,3.452-.377c-1.252-.668-2.349-1.48-2.394-2.288-.031-.527.309-.961,1.009-1.293a2.377,2.377,0,0,1,1.992-.057c2.087.869,3.38,4.46,3.434,4.614a.416.416,0,0,1-.016.311.585.585,0,0,1-.057.086h0a.384.384,0,0,1-.137.105c-.808.385-4.227,1.949-6.377,1.949A2.118,2.118,0,0,1,352.673,410.6Zm.853-1.978a.861.861,0,0,0-.439.539c-.154.6.037.761.1.814.724.6,3.544-.254,5.811-1.212C357.273,408.379,354.635,407.988,353.526,408.623Zm2.011-3.927c-.211.1-.56.3-.547.512.039.693,2.24,1.89,4.52,2.757-.533-1.164-1.5-2.835-2.64-3.308a1.612,1.612,0,0,0-.625-.133A1.643,1.643,0,0,0,355.537,404.7Z",
    transform: "translate(-352.218 -403.714)",
    fill: "#263238"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(74.555 424.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M341.97,405.863c-.029-1.252-15.415-.271-15.415-.271s-9.466,9.628-18.66,11.793-4.057,7.681,6.219,7.681h25.424C346.84,425.066,342.275,418.845,341.97,405.863Z",
    transform: "translate(-303.107 -402.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(13.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M310.5,410.6a1.474,1.474,0,0,1-.373-1.64,1.646,1.646,0,0,1,.822-1.041,6.281,6.281,0,0,1,3.45-.377c-1.25-.668-2.347-1.48-2.394-2.288-.031-.527.31-.961,1.011-1.293a2.376,2.376,0,0,1,1.992-.057c2.085.869,3.38,4.46,3.433,4.614a.407.407,0,0,1-.016.311.586.586,0,0,1-.055.086h0a.385.385,0,0,1-.137.105c-.81.385-4.227,1.949-6.377,1.949A2.115,2.115,0,0,1,310.5,410.6Zm.853-1.978a.864.864,0,0,0-.441.539c-.152.6.039.761.1.814.726.6,3.546-.254,5.813-1.212C315.1,408.379,312.459,407.988,311.35,408.623Zm2.011-3.927c-.211.1-.56.3-.549.512.039.693,2.242,1.89,4.52,2.757-.531-1.164-1.5-2.835-2.64-3.308a1.6,1.6,0,0,0-.623-.133A1.636,1.636,0,0,0,313.361,404.7Z",
    transform: "translate(-310.042 -403.714)",
    fill: "#263238"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M325.356,361.451l8.328-58.521V263.3c21.927-16.483,64.189-16.483,64.189-16.483s32.486,45.035,16.7,119.174l-40.763,5.955L371.2,358.116l-5.112,13.826Z",
    transform: "translate(-207.359 -128.44)",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M325.356,361.451l8.328-58.521V263.3c21.927-16.483,64.189-16.483,64.189-16.483s32.486,45.035,16.7,119.174l-40.763,5.955L371.2,358.116l-5.112,13.826Z",
    transform: "translate(-207.359 -128.44)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M348.837,324.916l7.851-24.387s8.242-2.5,18.818-18.863C375.507,281.666,373.673,309.521,348.837,324.916Z",
    transform: "translate(-184.993 -95.241)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M339.939,261.864l18.3-1.749s4.428,8.742,2.931,21.73l-11.739,7.043-8.493-6.031S340.689,267.359,339.939,261.864Z",
    transform: "translate(-193.468 -115.769)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M362.5,259.621a92.024,92.024,0,0,1,5.409,18.733L374.4,281.1l3.5-4.346s-2.376-12.76-6.373-19Z",
    transform: "translate(-171.982 -118.022)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M325.247,303.817l43.271,12.7-2.716,5.807-41.117-12.644Z",
    transform: "translate(-207.998 -74.142)",
    fill: "#41494d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M349.311,313.181l.714,5.339,42.428-5.339.656-6.744Z",
    transform: "translate(-184.541 -71.646)",
    fill: "#41494d"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(125.928 120.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M354.89,254.093a153.311,153.311,0,0,1,20.986-2.042l-2.611-4.321a119.144,119.144,0,0,0-20.462,1.224Z",
    transform: "translate(-307.143 -247.683)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M338.241,253.718c-5.592,2.419-8.824,4.249-8.824,4.249l.037,5.33c3.147-1.6,6.318-3.044,9.477-4.356Z",
    transform: "translate(-329.418 -241.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M335.708,263.078a171.022,171.022,0,0,1,33.6-9.351l-1.949-5.2a147.99,147.99,0,0,0-32.453,9.333Z",
    transform: "translate(-324.19 -246.878)",
    fill: "#263238"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 147.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M281.563,265.98l-11.088-4.452L268.6,271.992s10,6.068,14.162-1.154Z",
    transform: "translate(-261.418 -261.528)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M268.477,262.171l-3.554,8.1,7.184,1.722,1.872-10.463Z",
    transform: "translate(-264.923 -261.528)",
    fill: "#e4897b"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(177.044 22.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M367.987,211.991l-1.318-11.875-10.1,3.3s-.621,11.682,7.709,11.936Z",
    transform: "translate(-354.686 -195.571)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M364.414,197.788l-8.816.7,1.879,7.145,10.106-3.3Z",
    transform: "translate(-355.598 -197.788)",
    fill: "#e4897b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M325.469,256.983c-3.085-3.339-6.307-6.853-9.411-10.329-1.191-7.263-1.953-13.648-1.953-13.648A28.2,28.2,0,0,1,325.469,256.983Z",
    transform: "translate(-218.076 -141.591)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M345.077,230.209s-6.844,27.519-19.039,51c-7.023,13.527-52.048,17.7-52.048,17.7",
    transform: "translate(-256.287 -144.255)",
    fill: "none",
    stroke: "#dc897c",
    strokeMiterlimit: 10,
    strokeWidth: 8.842
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M317.742,223.859c-9.56,6.24-14.671,22.493-16.29,30.446l19.84,14.6,10.011-9.759C335.365,236.728,321.356,221.5,317.742,223.859Z",
    transform: "translate(-230.128 -150.532)",
    fill: "#407bff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M317.742,223.859c-9.56,6.24-14.671,22.493-16.29,30.446l19.84,14.6,10.011-9.759C335.365,236.728,321.356,221.5,317.742,223.859Z",
    transform: "translate(-230.128 -150.532)",
    fill: "#fff",
    opacity: 0.6
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(166.692 9.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M367.436,224.429l-14.158,1.507a1.431,1.431,0,0,1-1.49-1.515l-.855-30.018a1.727,1.727,0,0,1,1.4-1.822l14.158-1.507a1.431,1.431,0,0,1,1.49,1.515l.855,30.018A1.728,1.728,0,0,1,367.436,224.429Z",
    transform: "translate(-349.689 -191.067)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M367.436,224.429l-14.158,1.507a1.431,1.431,0,0,1-1.49-1.515l-.855-30.018a1.727,1.727,0,0,1,1.4-1.822l14.158-1.507a1.431,1.431,0,0,1,1.49,1.515l.855,30.018A1.728,1.728,0,0,1,367.436,224.429Z",
    transform: "translate(-349.689 -191.067)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M366.8,224.5,352.641,226a1.431,1.431,0,0,1-1.492-1.513l-.853-30.018a1.724,1.724,0,0,1,1.4-1.822l14.156-1.507a1.434,1.434,0,0,1,1.492,1.515l.853,30.018A1.722,1.722,0,0,1,366.8,224.5Z",
    transform: "translate(-350.296 -191.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M366.8,224.5,352.641,226a1.431,1.431,0,0,1-1.492-1.513l-.853-30.018a1.724,1.724,0,0,1,1.4-1.822l14.156-1.507a1.434,1.434,0,0,1,1.492,1.515l.853,30.018A1.722,1.722,0,0,1,366.8,224.5Z",
    transform: "translate(-350.296 -191.003)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M365.619,191.441l-3.7.394-.478,1.142-5.737.611-.539-1.035-3.7.394a1.123,1.123,0,0,0-.908,1.181l.855,30.018a.928.928,0,0,0,.966.982l14.158-1.507a1.122,1.122,0,0,0,.906-1.181l-.855-30.018A.931.931,0,0,0,365.619,191.441Z",
    transform: "translate(-350.049 -190.716)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M362.885,199.445l-10.415,1.109a.912.912,0,0,1-.951-.963l-.082-2.9a1.1,1.1,0,0,1,.888-1.16l10.417-1.109a.913.913,0,0,1,.949.965l.082,2.9A1.1,1.1,0,0,1,362.885,199.445Z",
    transform: "translate(-349.209 -187.873)",
    fill: "#fff",
    opacity: 0.8
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.bfc3ff305ae81ada4e429980a8cf4dc3.svg";
export { ForwardRef as ReactComponent };